// Milestone rates must be monotonically decreasing with higher trigger
// values: someone who hits milestone 5 has by definition also hit milestone
// 3, so rate(3) ≥ rate(5). When the user moves one slider, clamp the others
// so this invariant is preserved.
//
// changedKey is the slider the user just moved; newRate is its new value.
// Returns a fresh map with the clamped rates.
export function clampMilestoneRates(
  prev: Record<string, number>,
  milestoneKeys: string[], // sorted ascending by numeric value, e.g. ['3', '5', '10']
  changedKey: string,
  newRate: number,
): Record<string, number> {
  const next: Record<string, number> = { ...prev, [changedKey]: newRate };
  const ordered = [...milestoneKeys].sort((a, b) => Number(a) - Number(b));
  const idx = ordered.indexOf(changedKey);
  if (idx === -1) return next;

  // Lower milestones (smaller trigger value) must have rates ≥ newRate.
  for (let i = 0; i < idx; i++) {
    const k = ordered[i];
    if ((next[k] ?? 0) < newRate) next[k] = newRate;
  }
  // Higher milestones (larger trigger value) must have rates ≤ newRate.
  for (let i = idx + 1; i < ordered.length; i++) {
    const k = ordered[i];
    if ((next[k] ?? 0) > newRate) next[k] = newRate;
  }
  return next;
}
